import { render, staticRenderFns } from "./Settings_JCA.vue?vue&type=template&id=c88fbe48&scoped=true"
import script from "./Settings_JCA.vue?vue&type=script&lang=js"
export * from "./Settings_JCA.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c88fbe48",
  null
  
)

export default component.exports